import { $$ } from '../helpers/shortcuts';

import { Luminous } from 'luminous-lightbox';

const lightboxOptions = {
  showCloseButton: true,
  closeOnScroll: true,
};

const initializeLightbox = () => {
  const lightboxImages = $$('a.image-lightbox');
  for (const image of lightboxImages) {
    new Luminous(image, lightboxOptions);
  }
};

export { initializeLightbox };
